/* Floretti 3.0 — meescrollende winkelmandknop

   Drie dingen bepalen of hij zichtbaar is:
   1. zit er iets in de mand,
   2. ben je voorbij de header gescrold,
   3. staat de lade of het menu niet al open.

   De teller wordt niet zelf berekend maar afgelezen van de bubbel in de
   header. Dawn werkt die al bij na elke cart-mutatie; door hem te volgen is er
   geen tweede plek die de winkelmand moet begrijpen en kunnen de twee niet uit
   elkaar lopen. */
(function () {
  'use strict';

  class FlorettiCartFab extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-cart-fab-btn]');
      this.countEl = this.querySelector('[data-cart-fab-count]');
      this.labelEl = this.querySelector('[data-cart-fab-label]');
      this.headerCart = document.querySelector('#cart-icon-bubble');
      this.drawer = document.querySelector('cart-drawer');
      this.count = parseInt(this.dataset.count || '0', 10) || 0;
      this.voorbijHeader = false;

      if (this.btn) this.btn.addEventListener('click', this.openCart.bind(this));

      this.watchHeaderCount();
      this.watchScroll();
      this.watchDrawer();
      this.sync();
    }

    disconnectedCallback() {
      if (this._countObserver) this._countObserver.disconnect();
      if (this._drawerObserver) this._drawerObserver.disconnect();
      if (this._sentinelObserver) this._sentinelObserver.disconnect();
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      /* Anders blijft de teller in de header uitgedoofd terwijl deze knop weg is. */
      document.documentElement.classList.remove('floretti-fab-draagt-teller');
    }

    /* ---------- Aantal volgen ---------- */
    watchHeaderCount() {
      if (!this.headerCart || !('MutationObserver' in window)) return;
      this._countObserver = new MutationObserver(this.leesAantal.bind(this));
      this._countObserver.observe(this.headerCart, { childList: true, subtree: true, characterData: true });
    }

    leesAantal() {
      var bubble = this.headerCart && this.headerCart.querySelector('.cart-count-bubble span[aria-hidden]');
      var nieuw = bubble ? parseInt(bubble.textContent.trim(), 10) || 0 : 0;

      /* Geen bubbel betekent een lege mand — behalve als de header nog niet
         opnieuw is gerenderd. Dan houden we het oude aantal aan in plaats van
         de knop ten onrechte te laten verdwijnen. */
      if (!bubble && this.headerCart && !this.headerCart.querySelector('.cart-count-bubble')) nieuw = 0;

      if (nieuw === this.count) return;
      var erbij = nieuw > this.count;
      this.count = nieuw;
      this.sync();
      if (erbij) this.bump();
    }

    bump() {
      var self = this;
      this.classList.remove('is-bumping');
      // forceer herstart van de animatie
      void this.offsetWidth;
      this.classList.add('is-bumping');
      window.setTimeout(function () {
        self.classList.remove('is-bumping');
      }, 500);
    }

    /* ---------- Scrollpositie ---------- */
    watchScroll() {
      var self = this;
      var header = document.querySelector('.floretti-header');

      if (header && 'IntersectionObserver' in window) {
        /* De knop hoort pas te verschijnen als de header uit beeld is. De
           header zelf is sticky en blijft dus altijd "in beeld"; we kijken
           daarom naar een punt net onder de oorspronkelijke headerpositie. */
        this._sentinelObserver = new IntersectionObserver(
          function (entries) {
            self.voorbijHeader = !entries[0].isIntersecting;
            self.sync();
          },
          { rootMargin: '-160px 0px 0px 0px', threshold: 0 }
        );
        var sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
        document.body.prepend(sentinel);
        this._sentinelObserver.observe(sentinel);
        return;
      }

      this._onScroll = function () {
        var nu = window.scrollY > 160;
        if (nu === self.voorbijHeader) return;
        self.voorbijHeader = nu;
        self.sync();
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this._onScroll();
    }

    /* ---------- Lade en menu ---------- */
    watchDrawer() {
      if (!('MutationObserver' in window)) return;
      var self = this;
      this._drawerObserver = new MutationObserver(function () {
        self.sync();
      });
      if (this.drawer) this._drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
      this._drawerObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }

    isAfgedekt() {
      var ladeOpen = this.drawer && this.drawer.classList.contains('active');
      var menuOpen = document.documentElement.classList.contains('floretti-menu-open');
      return Boolean(ladeOpen || menuOpen);
    }

    /* ---------- Zichtbaarheid ---------- */
    sync() {
      var heeftItems = this.count > 0;
      this.hidden = !heeftItems;

      if (this.countEl) this.countEl.textContent = String(this.count);
      if (this.labelEl) this.labelEl.textContent = this.count + ' artikelen in je winkelwagen';

      var zichtbaar = heeftItems && this.voorbijHeader;
      var afgedekt = this.isAfgedekt();

      this.classList.toggle('is-visible', zichtbaar);
      this.classList.toggle('is-suppressed', afgedekt);

      /* Zolang deze knop het aantal draagt, dooft de teller in de header uit.
         Twee dezelfde getallen op één scherm lezen als een fout. De knop boven
         blijft wél staan: dat is de plek waar iedereen de winkelmand zoekt, en
         hem laten verspringen zou het spiergeheugen breken. Beide toestanden
         hangen aan dezelfde drempel, dus er is nooit een moment zonder teller. */
      document.documentElement.classList.toggle('floretti-fab-draagt-teller', zichtbaar && !afgedekt);
    }

    openCart() {
      if (this.drawer && typeof this.drawer.open === 'function') {
        this.drawer.open(this.btn);
        return;
      }
      /* Zonder lade (of als die nog niet is opgewaardeerd) is de winkelmandpagina
         de eerlijke terugval — beter dan een knop die niets doet. */
      window.location.href = this.dataset.cartUrl || '/cart';
    }
  }

  if (!customElements.get('floretti-cart-fab')) {
    customElements.define('floretti-cart-fab', FlorettiCartFab);
  }
})();
